import { Authenticated } from "@refinedev/core";
import { Flex } from "antd";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import { SubPageHeader } from "components/SubPageHeader/";
import { StudioTopBar } from "components/layout/header/StudioTopBar";
import { PresetDateRangePicker } from "components/PresetDateRangePicker/";
import { ANALYTICS_MAX_DATE_RANGE_MONTHS } from "constants/";
import { AnalyticsTabs } from "../components/analytics/AnalyticsTabs";
import { ActivityTimeline } from "../components/analytics/ActivityTimeline";
import { DEFAULT_ANALYTICS_DATE_RANGE } from "../constants";
import { useAnalyticsDateRange } from "./hooks/useAnalyticsDateRange";
import { useAnalyticsBack } from "./hooks/useAnalyticsBack";

export function ActivityAnalyticsPage() {
  const { id: projectId } = useParams<{ id: string }>();
  const { dateRange, setDateRange, project } = useAnalyticsDateRange(projectId);
  const handleBack = useAnalyticsBack();

  return (
    <Authenticated key="activityAnalytics">
      <SubPageHeader
        itemId={projectId}
        itemTitle={project?.title ?? ""}
        page="analytics"
        source="projects"
        spaced
        onBack={handleBack}
        rightContent={<StudioTopBar />}
      />
      <Flex vertical gap={24}>
        <AnalyticsTabs />
        <PresetDateRangePicker
          value={{
            type: dateRange.type || DEFAULT_ANALYTICS_DATE_RANGE,
            startDate: dateRange.startDate!,
            endDate: dateRange.endDate!,
          }}
          onChange={setDateRange}
          dateFormat="L"
          minDate={dayjs().subtract(ANALYTICS_MAX_DATE_RANGE_MONTHS, "months")}
        />

        {projectId && (
          <ActivityTimeline
            projectId={projectId}
            startDate={dateRange.startDate?.format("YYYY-MM-DD")}
            endDate={dateRange.endDate?.format("YYYY-MM-DD")}
          />
        )}
      </Flex>
    </Authenticated>
  );
}
